"use client";

import PackageModeMappingForm from "@/components/PackageModeMappingForm";
import PackageModeMappingTable from "@/components/PackageModeMappingTable";




export default function PackageModeMappingPage() {
  return (
    <>
      <PackageModeMappingForm />
      <PackageModeMappingTable/>
    </>
  );
}
